import './Input.scss';

export default function Input({ ...props }) {

  return (
    <input className="input" {...props} />
  );
}

export function Group({ children }) {
  return (
    <div className="input-group">{children}</div>
  )
}

export function Label({ children }) {
  return (
    <label className="input-label">{children}</label>
  )
}

export function Radio({ ...props }) {
  return (
    <input className="input-radio" type="radio" {...props} />
  );
}
